import { render, staticRenderFns } from "./MatchingLocationsRadarChart.vue?vue&type=template&id=081ad0ff&"
import script from "./MatchingLocationsRadarChart.vue?vue&type=script&lang=ts&"
export * from "./MatchingLocationsRadarChart.vue?vue&type=script&lang=ts&"
import style0 from "./MatchingLocationsRadarChart.vue?vue&type=style&index=0&id=081ad0ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports